var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-auto",attrs:{"color":"primary","elevation":"5","x-large":""},on:{"click":_vm.onSubmit}},[_vm._v(" Übersicht ")])}
var staticRenderFns = []

export { render, staticRenderFns }